const purchase = {
  title: "HitPaw Online Pro",
  subTitle: "Scegli il piano giusto con prezzi semplici e trasparenti",
  monthlyUppercase: "MENSILE",
  montly: "Mensile",
  free: "Gratis",
  yearlyUppercase: "ANNUALE",
  yearly: "Annuale",
  inService: "In servizio",
  buyBtn: "Acquista ora",
  freeTips1: "Supporta la dimensione massima del file di 20 MB",
  freeTips2: "6 file al giorno",
  freeTips3: "Velocità di elaborazione normale",
  freeTips4: "Velocità di download normale",
  freeTips5: "Una volta al giorno per rimuovere sfondo",
  freeTips6: "Accesso a tutti gli strumenti gratuiti",
  vipTips1: "Dimensione file illimitata",
  vipTips2: "File illimitati al giorno",
  vipTips3: "Velocità di download 10 volte più veloce",
  vipTips4: "Velocità di elaborazione 10 volte più veloce",
  vipTips5: "Illimitato",
  vipTips6: "Rimozione illimitata dello sfondo dell'immagine al giorno",
  vipTips7: "Accesso a tutti gli strumenti e alle funzionalità premium",
  vipTips8: "Rinnova automaticamente e annulla in qualsiasi momento.",
  vipTips9: "Nessun limite di dimensioni e quantità del video",
  vipTips10: "Rimuovi gli sfondi delle immagini senza limiti",
  vipTips11: "Elaborazione video 10 volte più veloce e velocità di download",
  vipTips12: "Accesso a tutti gli strumenti gratuiti e alle funzionalità premium",
  acceptTitle: "Accettiamo",
  modalTitle: "Esegui l'upgrade a Pro per accedere a tutte le funzionalità premium",
  total: "Totale",
  enterCode: "Inserisci il codice",
  SignUpToPurchaseBtn: "Registra per acquistare",
  purchaseBtn: "Vai all'acquisto",
  saveTips: "Risparmia fino al {{num}}%",
  discount: "Sconto",
  purchaseTips: "Rinnova automaticamente e annulla in qualsiasi momento.",
  tips: "Suggerimenti:",
  promoCodeInvalidTips: "Il tuo codice promozionale non è valido",
};

export default purchase;
